import React from 'react';

import useUserHook from 'hooks/useUserHook';

import { QuickLinkCard } from 'components/Mobile/components/quickLinkCard';
import classes from 'components/Mobile/pages/home/components/QuickLinks/quickLinks.module.scss';
import { useHomeQuickLinks } from 'components/Mobile/pages/home/hooks/useHomeQuickLinks';

interface QuickLink {
    name: string;
    gotoFunc?: () => void;
    filter?: {};
}

const DEFAULT_CARD_ACTIVITY = { cardActivity: ['TASK_DEPENDENT', 'START_MILESTONE'] };

export const QuickLinks = () => {
    const { goToActivitiesByFilter } = useHomeQuickLinks();
    const { username } = useUserHook();

    const goToProgramBoardView = () => {
        goToActivitiesByFilter({
            ...DEFAULT_CARD_ACTIVITY,
        });
    };

    const goToProgramUpdatedByMe = () => {
        goToActivitiesByFilter({
            updatedBy: username,
            ...DEFAULT_CARD_ACTIVITY,
        });
    };

    const goto30dLookAhead = () => {
        goToActivitiesByFilter({
            finishDate: {
                value: 'TODAY_REF_NEXT_30_DAYS',
                type: 'TODAY_REF',
            },
            ...DEFAULT_CARD_ACTIVITY,
        });
    };

    const gotoMyTrackedActivities = () => {
        goToActivitiesByFilter({
            trackedActivity: '1',
            ...DEFAULT_CARD_ACTIVITY,
        });
    };

    const gotoMyPriorities = () => {
        goToActivitiesByFilter({
            status: ['TODO', 'IN_PROGRESS'],
            ...DEFAULT_CARD_ACTIVITY,
            assignee: username,
        });
    };
    const quickLinksObj: QuickLink[] = [
        {
            name: 'All Activities',
            gotoFunc: goToProgramBoardView,
        },
        {
            name: '30d Lookahead',
            gotoFunc: goto30dLookAhead,
        },
        {
            name: 'My Priorities',
            gotoFunc: gotoMyPriorities,
        },
        {
            name: 'Activities updated by me',
            gotoFunc: goToProgramUpdatedByMe,
        },
        {
            name: 'My Tracked Activities',
            gotoFunc: gotoMyTrackedActivities,
        },
    ];

    return (
        <>
            <div className={classes.headline}>Quick Links</div>
            {quickLinksObj &&
                quickLinksObj.length > 0 &&
                quickLinksObj.map((item) => (
                    <QuickLinkCard
                        key={item.name}
                        title={item.name}
                        action={item.gotoFunc ? item.gotoFunc : () => {}}
                    />
                ))}
        </>
    );
};
